import styles from "../../search-menu.module.scss";
import type { SearchMenuListViewProps } from "./types-list";

export function SearchMenuListView({
  label,
  className,
  onKeyDown,
  rest,
  children,
}: SearchMenuListViewProps) {
  return (
    <ul
      className={[styles.list, className].filter(Boolean).join(" ")}
      aria-label={label}
      {...rest}
      role="menu"
      onKeyDown={onKeyDown}
    >
      {children}
    </ul>
  );
}
